import { render, staticRenderFns } from "./SalaryFormulaSetup.vue?vue&type=template&id=341e283f&scoped=true"
import script from "./SalaryFormulaSetup.vue?vue&type=script&lang=js"
export * from "./SalaryFormulaSetup.vue?vue&type=script&lang=js"
import style0 from "./SalaryFormulaSetup.vue?vue&type=style&index=0&id=341e283f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341e283f",
  null
  
)

export default component.exports